import { useCallback, useState } from "react";

export type ViewMode = "cards" | "list";

const DEFAULT_VIEW_MODE: ViewMode = "cards";

const readViewMode = (storageName: string): ViewMode => {
  try {
    const stored = window.localStorage.getItem(storageName);
    return stored === "list" || stored === "cards" ? stored : DEFAULT_VIEW_MODE;
  } catch {
    // A browser that refuses storage must never stop the page from rendering.
    return DEFAULT_VIEW_MODE;
  }
};

/** Cards or list, remembered per browser under the given storage name. */
export const useViewMode = (
  storageName: string
): [ViewMode, (mode: ViewMode) => void] => {
  const [mode, setModeState] = useState<ViewMode>(() =>
    readViewMode(storageName)
  );

  const setMode = useCallback(
    (next: ViewMode) => {
      setModeState(next);
      try {
        window.localStorage.setItem(storageName, next);
      } catch {
        // Private browsing and quota errors are not worth surfacing.
      }
    },
    [storageName]
  );

  return [mode, setMode];
};
